import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpRequest} from '@angular/common/http';

import {environment} from '@env/environment';


@Injectable()
export class HttpErrorMessageService {

  constructor() {
  }

  /**
   * @desc construct and return user friendly message including the message provided by backend
   * @param httpErrorResponse - http error response
   * @param req - http request
   */
  getErrorMessage(httpErrorResponse: HttpErrorResponse, req?: HttpRequest<any>): string {
    let errorMsg: string;
    let errorDetailMsg: string;

    console.error(httpErrorResponse);

    if (!httpErrorResponse || !httpErrorResponse.error) {
      return 'Unknown HTTP error.';
    }

    if (httpErrorResponse.status) {
      errorMsg = `(${httpErrorResponse.status}) `;
    }

    if (httpErrorResponse.error && httpErrorResponse.error.errorMessages) {
      errorDetailMsg = httpErrorResponse.error.errorMessages[environment.growlContent];
    }

    // 400 http://localhost:38080/auth/realms/mu/protocol/openid-connect/token
    // {"error":"invalid_grant","error_description":"Session not active"}
    //
    switch (httpErrorResponse.status) {
      case 0: {
        errorMsg += `Login failure or unknown error.`;
        break;
      }
      case 400: {
        errorMsg += `Data error.`;
        console.log(httpErrorResponse);
        console.log(req);
        if (httpErrorResponse.url.includes("protocol/openid-connect/token") && httpErrorResponse.error=="invalid_grant") {
          console.error("need to route to login page!!");
        }
        break;
      }
      case 401 || 403: {
        errorMsg += `Not permitted to access the resource. Please re-login or obtain necessary access.`;
        break;
      }
      case 404: {
        errorMsg += `Requested page is not found.`;
        break;
      }
      case 424: {
        errorMsg += `Request failed because of its dependency.`;
        break;
      }
      case 500: {
        errorMsg += `Internal server error.`;
        break;
      }
      case 503: {
        errorMsg += `Service not available.`;
        break;
      }
      default: {
        errorMsg += `Unknown HTTP error.`;
        break;
      }
    }

    if (errorDetailMsg) {
      let evidence = httpErrorResponse.error.evidence ? httpErrorResponse.error.evidence.substring(13) : null;
      errorMsg += ` ${errorDetailMsg} - ${evidence}`;
    }

    return errorMsg;
  }
}
